import styled from 'styled-components';

export const StyledBookmarkItem = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    &:after {
      content: '';
      border: 0.5px solid rgba(200, 200, 200, 0.6);
      margin-bottom: 1em;
      width: 100%;
      height: 0;
    }
  }
`;

export const StyledBookmarkItemPages = styled.button`
  align-self: flex-start;
  appearance: none;
  background-color: transparent;
  border: 0;
  color: #0f4c81;
  cursor: pointer;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const StyledBookmarkItemText = styled.p`
  color: #1d1d1f;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0.5em 0 1.25em 0;
`;

export const StyledBookmarkItemTimestamp = styled.p`
  color: #4f4f4f;
  font-size: 0.88875rem;
  margin: 0 0 1.5rem 0;
`;
